export const decodeBase64 = str => {
  try {
    return JSON.parse(atob(str));
  } catch (e) {
    console.error('Failed to decode:', e);
    return {};
  }
};
